import React from "react"
import Newsletter from "./newsletter";

const Headings = ({title, description, pageContext}) => {

    return (
        <>
            <section
                className="page-header"
                style={{
                    background:
                        "linear-gradient( rgba(139, 192, 235, 1), rgba(0, 0, 0, 0) ), url(https://strapi.beach.poi-nt.com/uploads/header_beach_a184fac02f.jpg)",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "top center",
                }}
            >
                <div className="container">
                    {title && <h2><span>{title}</span></h2>}
                    {description && (
                        <p className="mt-4 text-2xl text-neutral-500">{description}</p>
                    )}
                    <Newsletter pageContext={pageContext}/>
                </div>
            </section>
        </>
    )
}

export default Headings
